import { Box } from '@material-ui/core'
import React from 'react'
import {
  FunctionField,
  ReferenceField,
  Show,
  ShowProps,
  SimpleShowLayout,
  TextField,
  useShowContext,
  useTranslate,
} from 'react-admin'
import { TicketImportDto } from '../../core/dto/ticket-import.dto'
import { ResourceName } from '../../core/ResourceName'

const ShowTitle = ({ ...props }) => {
  const { record: ticketImportUpdate } = props
  const translate = useTranslate()

  return (
    <span>
      {translate('resources.ticket-import-updates.titles.show')}:{' '}
      {ticketImportUpdate?.name}
    </span>
  )
}

const TicketImportUpdate = ({ ...props }) => {
  const translate = useTranslate()
  const { record: ticketImport } = useShowContext()

  return (
    <SimpleShowLayout {...props}>
      <TextField source="id" label="Id" />
      <TextField source="name" />
      <TextField source="originalFileName" />
      <FunctionField<TicketImportDto>
        source="state"
        render={(r) => (
          <div>
            {translate(`resources.enums.TicketImportUpdateStates.${r?.state}`)}
          </div>
        )}
      />
      <ReferenceField source="jobId" reference={ResourceName.JOBS} link="show">
        <TextField source="jobId" />
      </ReferenceField>
      {ticketImport?.importUpdatesIds && (
        <FunctionField<TicketImportDto>
          label="Import Updates"
          render={(r) => (
            <Box>
              {r?.importUpdatesIds.map((id) => (
                <ReferenceField
                  key={id}
                  source="jobId"
                  record={{ id }}
                  reference={ResourceName.JOBS}
                  link="show"
                  basePath={`/${ResourceName.JOBS}`}
                >
                  <TextField source="jobId" />
                </ReferenceField>
              ))}
            </Box>
          )}
        />
      )}
    </SimpleShowLayout>
  )
}

export const TicketImportUpdateShow = (props: ShowProps) => (
  <Show {...props} actions={false} title={<ShowTitle />}>
    <TicketImportUpdate />
  </Show>
)
